/**
 * Shared allow-list of hosts on which client-side telemetry (PostHog) is
 * enabled. Used by both the PostHog init gate in `src/main.tsx` and by the
 * screen-load telemetry emitters in `src/lib/routeTiming.ts`.
 *
 * Preview hosts (`id-preview--*.lovable.app`, `*.lovableproject.com`) are
 * intentionally excluded so preview traffic does not pollute analytics.
 */
export const TELEMETRY_ALLOWED_HOSTS = [
  "groundedtheapp.com",
  "www.groundedtheapp.com",
  // Default published Lovable URL. Still receives real traffic from early
  // bookmarks, share links, and the Despia native shell fallback.
  "grounded-cafe-finder.lovable.app",
] as const;

export function isTelemetryAllowedHost(
  host: string = typeof window !== "undefined" ? window.location.hostname : "",
): boolean {
  return (TELEMETRY_ALLOWED_HOSTS as readonly string[]).includes(host);
}
